import {Alert, Box, Typography} from "@mui/material";
import {blue, grey, red} from "@mui/material/colors";
import {useAppContext} from "@/contexts/AppContext.tsx";

interface MainInformationFactProps {
    variant?: 'text' | 'alert'
    align?: 'left' | 'center' | 'right'
    children?: any,
    severity?: 'info' | 'success' | 'error'
}

export default function MainInformationFact({
                                                variant = 'text',
                                                align = 'left',
                                                severity = 'info',
                                                children
                                            }: MainInformationFactProps) {
    const {uiVisual, theme} = useAppContext();

    const alert = {
        classic: {
            display: "block",
            bgcolor: theme === 'dark' ? grey[200] : severity === 'error' ? '#fff3f5' : '#f1f5ff',
            color: severity === 'error' ? red[900] : blue[900],
            "svg": {fill: theme === 'dark' ? grey[700] : severity === 'error' ? red[900] : blue[900]},
            borderRadius: 1
        },
        modern: {
            display: "block",
            bgcolor: theme === 'dark' ? grey[200] : severity === 'error' ? '#fff3f5' : '#f1f5ff',
            color: severity === 'error' ? red[900] : blue[900],
            "svg": {fill: theme === 'dark' ? grey[700] : severity === 'error' ? red[900] : blue[900]},
            borderRadius: 2
        }
    }

    const text = {
        classic: theme === 'dark' ? grey[700] : blue[900],
        modern: theme === 'dark' ? grey[700] : blue[900]
    }

    if (variant === 'alert') {
        return (
            <Alert severity="info" sx={{...alert[uiVisual], display: ''}}>
                {children?.length === 1 ? (
                    <Typography fontSize={13} color={text[uiVisual]}>
                        {children}
                    </Typography>
                ) : children}
            </Alert>
        )
    }

    return (
        <Box p={2} textAlign={align} sx={alert[uiVisual]} fontSize={13}>
            {children?.length === 1 ? (
                <Typography color={text[uiVisual]}>
                    {children}
                </Typography>
            ) : children}
        </Box>
    )
}